// @flow
import React, { Component, Fragment } from "react";
import classNames from "classnames";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { withStyles } from "@material-ui/core/styles";

import { SingleCheckBox, StyledTextField } from "imagus-components";

const styles = (theme: *): * => ({
  greenLabel: {
    color: theme.palette.primary.light,
    "&$labelFocused": {
      color: theme.palette.primary.main
    },
    "&$labelError": {
      color: theme.palette.error.main
    },
    "&$labelDisabled": {
      color: theme.palette.grey.main
    }
  },
  labelFocused: {},
  labelError: {},
  labelDisabled: {},
  textFieldFormLabel: {
    fontSize: "1.0625rem",
    fontWeight: 500,
    padding: "10px 5px"
  },
  paper: {
    width: "100%"
  },
  helper: {
    verticalAlign: "middle",
    textAlign: "center"
  },
  checkboxAdjust: {
    marginTop: "-5px"
  }
});

type KeyValuePairsInputPropsType = {
  classes: { [key: string]: * },
  label: string,
  name: string,
  value: Array<PairType>,
  isRequired: boolean,
  isInvalid: boolean,
  syncChange: Function
};

type PairType = {
  name: string,
  version: string,
  data: string,
  selected: boolean
};

type KeyValuePairsInputStatesType = {
  pairs: Array<PairType>
};

const defaultPair = (): * => ({
  name: "",
  version: "1.0",
  data: "",
  selected: false
});

class KeyValuePairsInput extends Component<
  KeyValuePairsInputPropsType,
  KeyValuePairsInputStatesType
> {
  constructor(props: KeyValuePairsInputPropsType) {
    super(props);
    this.state = {
      pairs: []
    };
  }

  componentDidMount() {
    let pairs = [...this.props.value];
    pairs.push(defaultPair());
    this.setState({ pairs: pairs });
  }

  componentDidUpdate(prevProps: KeyValuePairsInputPropsType) {
    if (prevProps.value !== this.props.value) {
      let pairs = [...this.props.value];
      pairs.push(defaultPair());
      this.setState({ pairs: pairs });
    }
  }

  handleChange = (index: number): * => (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;
    let pairs = [...this.state.pairs];
    pairs[index][name] = value;

    if (name === "name" && index === this.state.pairs.length - 1) {
      pairs[index].selected = true;
      pairs.push(defaultPair());
    }

    this.setState({ pairs: pairs }, this.syncChange);
  };

  handleCheckBoxChange = (index: number): * => (
    e: SyntheticInputEvent<*>
  ): * => {
    const name = e.target.name;
    let pairs = [...this.state.pairs];
    pairs[index][name] = !pairs[index][name];
    this.setState({ pairs: pairs }, this.syncChange);
  };

  syncChange = (): * => {
    const pairs = [...this.state.pairs];
    this.props.syncChange(this.props.name, pairs.slice(0, pairs.length - 1));
  };

  render(): React$Element<*> {
    const classes = this.props.classes;

    return (
      <Grid container spacing={8}>
        <Grid item xs={12}>
          <FormControl fullWidth={true}>
            <InputLabel
              required={this.props.isRequired}
              error={this.props.isInvalid}
              shrink={true}
              classes={{
                root: classes.greenLabel,
                formControl: classes.textFieldFormLabel,
                focused: classes.labelFocused,
                error: classes.labelError,
                disabled: classes.labelDisabled
              }}
            >
              {this.props.label}
            </InputLabel>
          </FormControl>
        </Grid>
        <Paper className={classes.paper}>
          <Grid container spacing={0}>
            <Grid item xs={1}></Grid>
            <Grid item xs={4}>
              <div className={classes.helper}>Name</div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.helper}>Version</div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.helper}>Data</div>
            </Grid>
          </Grid>
          {this.state.pairs.map((pair: PairType, i: number): * => {
            return (
              <Grid container spacing={0} key={i}>
                <Grid item xs={1} className={classes.checkboxAdjust}>
                  <SingleCheckBox
                    name="selected"
                    value={pair.selected}
                    onChange={this.handleCheckBoxChange(i)}
                  />
                </Grid>
                <Grid item xs={4}>
                  <StyledTextField
                    name="name"
                    value={pair.name}
                    onChange={this.handleChange(i)}
                    inpuType="text"
                    label=""
                  />
                </Grid>
                <Grid item xs={3}>
                  <StyledTextField
                    name="version"
                    value={pair.version}
                    onChange={this.handleChange(i)}
                    inpuType="text"
                    label=""
                  />
                </Grid>
                <Grid item xs={4}>
                  <StyledTextField
                    name="data"
                    value={pair.data}
                    onChange={this.handleChange(i)}
                    inpuType="text"
                    label=""
                  />
                </Grid>
              </Grid>
            );
          })}
        </Paper>
      </Grid>
    );
  }
}

export default withStyles(styles)(KeyValuePairsInput);
